<template>
    <div>
        <!--        <v-toolbar dense>-->
        <!--            <v-row>-->
        <!--                <v-col>-->
        <!--                    <span><v-icon class="mr-3" color="primary">mdi-file-document-box-multiple-outline</v-icon></span>-->
        <!--                    <span class="title colorPrimary">Result</span>-->
        <!--                </v-col>-->
        <!--            </v-row>-->
        <!--        </v-toolbar>-->
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-card>
                        <v-app-bar color="accent" dark>
                            <v-icon class="mr-3">mdi-filter</v-icon>
                            <v-toolbar-title>Filters</v-toolbar-title>
                        </v-app-bar>
                        <v-container fluid>
                            <v-row dense>
                              <!--<v-col cols="12" md="3" lg="3">
                                <v-select :items="data.financingType"
                                          chips small-chips deletable-chips
                                          label="Financing Type" solo />
                              </v-col>-->
                                <v-col cols="12" md="3" lg="3">
                                    <v-select
                                            :items="data.schemeDropDownData"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Product"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="3" lg="3">
                                    <v-select
                                            :items="data.branch"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Branch"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="3" lg="3">
                                    <v-select
                                            :items="data.financingAmount"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Financing Amount Range"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="3" lg="3">
                                    <v-select
                                            :items="data.gfiStatus"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="GFI Status"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="3" lg="3">
                                    <v-select
                                            :items="data.bfe"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Business Financing Executive"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="3" lg="3">
                                    <v-select
                                            :items="data.stmanag"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="State Manager"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="3" lg="3">
                                    <v-select
                                            :items="data.completionYear"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Year"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="6" lg="12" class="d-flex justify-end">
                                    <v-btn color="accent" dark>Reset</v-btn>
                                    <v-btn color="primary" class="ml-3" dark>Filter</v-btn>
                                </v-col>


                            </v-row>

                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-card>
                        <v-app-bar color="accent" dark>
                            <v-icon class="mr-3">mdi-account-group</v-icon>
                            <v-toolbar-title>Customers</v-toolbar-title>
                            <v-row justify="end">
                                <v-dialog max-width="450" persistent v-model="dialog">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="secondary" dark v-on="on"
                                        >View Applied Filters
                                        </v-btn
                                        >
                                    </template>
                                    <v-card>
                                        <v-card-title class="headline"
                                        >Filters Applied
                                        </v-card-title
                                        >
                                        <v-card-text>
                                            <v-simple-table>
                                                <template v-slot:default>
                                                    <tbody>
                                                    <!--<tr>
                                                        <td>Financing Type</td>
                                                        <td>:</td>
                                                        <td>All Financing Types</td>
                                                    </tr>-->
                                                    <tr>
                                                        <td width="200">Product</td>
                                                        <td>:</td>
                                                        <td>All Products</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Branch</td>
                                                        <td>:</td>
                                                        <td>All Branches</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Financing Amount Range</td>
                                                        <td>:</td>
                                                        <td>All Financing Amount</td>
                                                    </tr>
                                                    <tr>
                                                        <td>GFI Status</td>
                                                        <td>:</td>
                                                        <td>All GFI Status</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Business Financing Executive</td>
                                                        <td>:</td>
                                                        <td>All Business Financing Executives</td>
                                                    </tr>
                                                    <tr>
                                                        <td>State Manager</td>
                                                        <td>:</td>
                                                        <td>All State Managers</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Year</td>
                                                        <td>:</td>
                                                        <td>All Years</td>
                                                    </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-card-text>
                                        <v-card-actions>
                                            <div class="flex-grow-1"></div>
                                            <v-btn @click="dialog = false" color="green darken-1" text
                                            >Close
                                            </v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-row>
                        </v-app-bar>
                        <v-card-title>
                            <v-row>
                                <v-col md="8"/>
                                <v-text-field label="Search"/>
                                <v-btn class="ma-2" color="primary" dark>
                                    <v-icon dark>mdi-magnify</v-icon>
                                </v-btn>
                            </v-row>
                        </v-card-title>
                        <v-row class="ml-3">
                <span :key="index" v-for="(headers, index) in headers">
                  <v-col v-if="headers.toggle">
                    <v-checkbox :label="headers.text" color="primary" v-model="headers.selectedCheckbox"/>
                  </v-col>
                </span>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-data-table
                                        :headers="filteredHeaders"
                                        :items="data.tableDataWrapper.rowData"
                                        :search="search"
                                        :items-per-page=10
                                        :footer-props="{
                                            'items-per-page-options': [10],
                                            'show-current-page':true
                                        }">
                                    <template v-slot:item.test_taker_id="{ item }">

                                        <span v-if="item.gfi_rating>=740 && item.gfi_rating<=800">Safe</span>
                                        <span v-else-if="item.gfi_rating>=580 && item.gfi_rating<=739">Low Risk</span>
                                        <span v-else-if="item.gfi_rating>=420 && item.gfi_rating<=579">Moderate Risk</span>
                                        <span v-else-if="item.gfi_rating>=300 && item.gfi_rating<=419">Risky</span>
                                        <span v-else-if="item.gfi_rating>=200 && item.gfi_rating<=299">Unacceptable Risk</span>
                                        <span v-else>-</span>

                                    </template>

                                    <template v-slot:item.loan_amount="{ item }">
                                        <span>{{item.loan_amount.toLocaleString()}}</span>
                                    </template>

                                    <template v-slot:item.gfi_rating="{ item }">
                                        <span v-if="!item.gfi_rating">-</span>
                                        <span v-else>{{item.gfi_rating}}</span>
                                    </template>

                                    <template v-slot:item.report_available="{ item }">
                                        <span v-if="item.report_available">
                                            <v-btn :href="'pdf/bank/report.pdf'" target="_blank" icon
                                                   text>
                                                <v-icon color="green">mdi-file-download</v-icon>
                                            </v-btn>
                                        </span>
                                        <span v-else>
                                            <v-btn disabled icon text>
                                                <v-icon>mdi-file-download</v-icon>
                                            </v-btn>
                                        </span>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    const data = require('../data/sample')
    export default {
        name: 'Result',
        data() {
            return {
                data,
                search: '',
                hideColumn: false,
                dialog: false,
                selectedCheckbox: true,
                table: {
                    tableData: [],
                    totalLength: 0
                },
                headers: [
                    {
                        text: 'No. ',
                        align: 'center',
                        sortable: false,
                        value: 'id',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Business Registration (BR) No.',
                        align: 'center',
                        sortable: false,
                        value: 'br_number',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Company Name',
                        align: 'center',
                        sortable: false,
                        value: 'company_name',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Identification number (ID)',
                        align: 'center',
                        sortable: false,
                        value: 'id_number',
                        selectedCheckbox: true,
                        toggle: false
                    },


                    {
                        text: 'Staff ID No.',
                        align: 'center',
                        sortable: false,
                        value: 'officer_id',
                        selectedCheckbox: true,
                        toggle: true
                    },
                    {
                        text: 'Product',
                        align: 'center',
                        sortable: false,
                        value: 'scheme_name',
                        selectedCheckbox: true,
                        toggle: true
                    },
                    {
                        text: 'Branch',
                        align: 'center',
                        sortable: false,
                        value: 'branch',
                        selectedCheckbox: true,
                        toggle: true
                    },
                    {
                        text: 'Financing Amount Requested (RM)',
                        align: 'center',
                        sortable: false,
                        value: 'loan_amount',
                        selectedCheckbox: true,
                        toggle: true
                    }, {
                        text: 'GFI Completion Date',
                        align: 'center',
                        sortable: false,
                        value: 'gfi_completion_date',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'GFI Status',
                        align: 'center',
                        sortable: false,
                        value: 'gfi_status',
                        selectedCheckbox: true,
                        toggle: true
                    },
                    {
                        text: 'Expiry Date',
                        align: 'center',
                        sortable: false,
                        value: 'expiry_date',
                        selectedCheckbox: false,
                        toggle: true
                    },
                    {
                        text: 'GFI Credit Score',
                        align: 'center',
                        sortable: false,
                        value: 'gfi_rating',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'GFI Rating',
                        align: 'center',
                        sortable: false,
                        value: 'test_taker_id',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'GFI Report',
                        align: 'center',
                        sortable: false,
                        value: 'report_available',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Application Status',
                        align: 'center',
                        sortable: false,
                        value: 'application_status',
                        selectedCheckbox: true,
                        toggle: false
                    }
                ]
            }
        },
        methods: {
            showColumn: function (col) {
                return this.headers.find(h => h.value === col).selected
            },
            hideColumnData: function () {
                this.hideColumn = !this.hideColumn
            }
        },
        computed: {
            filteredHeaders() {
                return this.headers.filter(h => h.selectedCheckbox)
            }
        }
    }
</script>

<style scoped></style>
